import { render, staticRenderFns } from "./historytakingfamilyhistory.vue?vue&type=template&id=1355b9ad&"
import script from "./historytakingfamilyhistory.vue?vue&type=script&lang=js&"
export * from "./historytakingfamilyhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports